import { ViewModel,View } from "binder"
import moment, { min } from "moment";
import { ServerConnection } from "src/server/serverConnection";
import { getAsNumber } from "src/uicomponents/components/utilities";
import { IPaymentMethod, singlePayment } from "../invoicePayment/invoicePayment-viewModel";
import  { CreditPaymentView } from "./creditPayment-view"

export class CreditPaymentViewModel extends ViewModel implements IPaymentMethod{
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
        this.paymentTypeName = 'پرداخت اعتباری';
    }

    GetDefaultView(): View <ViewModel> {
        return new CreditPaymentView();
    }
    public getTypeId(): string {
        return "VM-0E8425E1-73BD-4631-88E0-CBF4BBFADB98"
    }
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    public set paymentTypeName(v: string) { this._paymentTypeName = v; } public get paymentTypeName(): string { return this._paymentTypeName;} private _paymentTypeName: string;
    
    public set maxAmount(v: number) { this._maxAmount = v; this.updateInitialAmount(); } public get maxAmount(): number { return this._maxAmount;} private _maxAmount: number;
    public set amount(v: number) { 
        this._amount = getAsNumber(v,true);
        this.checkAmountValidity();
    } public get amount(): number { return this._amount;} private _amount: number;
    public set invoiceId(v: string) { this._invoiceId = v; } public get invoiceId(): string { return this._invoiceId;} private _invoiceId: string;
    public set isAmountInvalid(v: boolean) { this._isAmountInvalid = v; } public get isAmountInvalid(): boolean { return this._isAmountInvalid;} private _isAmountInvalid: boolean;
    public set maxCredit(v: number) { 
        this._maxCredit = v; 
        this.updateInitialAmount();
    } public get maxCredit(): number { return this._maxCredit;} private _maxCredit: number;
    public set customerCredit(v: number) { this._customerCredit = v; } public get customerCredit(): number { return this._customerCredit;} private _customerCredit: number;
    public set customerCreditDaysCount(v: string) { this._customerCreditDaysCount = v; } public get customerCreditDaysCount(): string { return this._customerCreditDaysCount;} private _customerCreditDaysCount: string;
    public set customerAccountBalance(v: number) { this._customerAccountBalance = v; } public get customerAccountBalance(): number { return this._customerAccountBalance;} private _customerAccountBalance: number;
    public set customerCreditType(v: string) { this._customerCreditType = v; } public get customerCreditType(): string { return this._customerCreditType;} private _customerCreditType: string;
    public set isAccountBalanceDebit(v: boolean) { this._isAccountBalanceDebit = v; } public get isAccountBalanceDebit(): boolean { return this._isAccountBalanceDebit;} private _isAccountBalanceDebit: boolean;
    public set accountBalanceLabel(v: string) { this._accountBalanceLabel = v; } public get accountBalanceLabel(): string { return this._accountBalanceLabel;} private _accountBalanceLabel: string;
    public set isFromRootDistrict(v: boolean) { this._isFromRootDistrict = v; } public get isFromRootDistrict(): boolean { return this._isFromRootDistrict;} private _isFromRootDistrict: boolean;
    
    private updateInitialAmount(){
        if(this.maxCredit !=null && this.maxAmount != null)
            this.amount = Math.min(this.maxAmount,this.maxCredit);
        else if(this.maxCredit == null)
            this.amount = this.maxAmount;
        else if(this.maxAmount == null)
            this.amount = 0;
    }

    private checkAmountValidity(){
        
        if(this.amount>this.maxCredit){
            this.amount = this.maxCredit;
        }
        if(this.amount > this.maxAmount){
            this.amount = this.maxAmount;
        }
    }    
    clear() {
        
    }
    async load(){
        try {
            this.isLoading = true;
            let result = await ServerConnection.callServer('/Complex/CreditServices/GetCustomerCredit',{
                InvoiceId:this.invoiceId,
                IsForDistrictSale : !this.isFromRootDistrict
            });
            this.customerCredit = result.Amount;
            this.customerAccountBalance = Math.abs(result.CustomerAccountBalance);
            this.isAccountBalanceDebit = result.CustomerAccountBalance > 0 ? true : false;
            this.accountBalanceLabel = this.isAccountBalanceDebit ? 'بدهکار' : 'بستانکار';
            this.customerCreditType = result.Type == 1 ? 'ماهانه' : 'روزانه';
            this.customerCreditDaysCount = result.Type == 1 ? 'ماهانه' : result.DaysCount;
            this.maxCredit = Math.max(this.customerCredit - result.CustomerAccountBalance, 0);
        } catch (ex) {
            console.log(ex);
        } finally {
            this.isLoading = false;
        }
    }
    public async createPayment(){
        let validationResult = this.validateInput();
        if(validationResult==''){
            try {
                this.isLoading = true;
                var confirmationResult = await this.messageBoxSuccessYesNo(`آیا پرداخت با مبلغ ${this.amount} صحیح است؟`,'پرداخت اعتباری');
                if(confirmationResult=='no'){
                    return;
                }
                let result = await ServerConnection.callServer('/Complex/SellServices/AddCreditPayment',{
                    InvoiceId:this.invoiceId,
                    Amount:this.amount
                });
                if(result.IsSuccessful){
                    await this.messageBoxConfirmSuccess('پرداخت با موفقیت ثبت شد','پرداخت اعتباری');
                    var payment = new singlePayment(this.parentViewModel);
                    payment.setConfirmationStatus(true);
                    payment.method = 'پرداخت اعتباری';
                    payment.methodNo = 11;
                    payment.amount = this.amount;
                    payment.time = moment.utc(moment.now());
                    this.onNewPaymentCreated(payment);
                } else {
                    if (result.Faults[0].Parameters.FaultId === "8E9EEFBC-C6A3-4088-B60A-E1B649EE679A"){
                        throw "زمان یا مبلغ اعتبار مشتری یه پایان رسیده است. لطفا پرداخت را برای فاکتورهای نهایی شده وی انجام دهید.";
                    }else if (result.Faults[0].Parameters.FaultId === "6CFFE6CC-63FC-4C3D-8976-6E1677020051"){
                        throw "مانده حساب بیشتر از اعتبار مشتری است.";
                    }else if (result.Faults[0].Parameters.FaultId === "A225C3C9-7A44-4CF0-A440-B14C4DD9B8B1")
                        throw "پرداخت اعتباری باید فاکتور را تسویه کند.";
                    throw "خطا در انجام عملیات";
                }
            } catch (ex) {
                console.log(ex);
                await this.messageBoxConfirmWarning(ex,"خطا")
            } finally {
                this.isLoading = false;
            }
        }else{
            await this.messageBoxConfirmWarning(validationResult,"خطا")
        }
    }

    private validateInput():string{
        let errors :string[]= []
        if(this.amount<=0){
            errors.push('مبلغ به درستی تنظیم نشده است');
        }
        return errors.join("\n");
    }

    onNewPaymentCreated(payment: singlePayment) {
    }
}

